import React from 'react';
import { MuiPopup } from '../molecules/popupComponent';
import { YellowWarningIcon } from '../../assets/images';
import { MuiStack } from '../atoms/stackComponent';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiLoaderButton } from '../atoms/loaderButton';
var OdometerConfirmPopUp = function (props) {
    var isOpen = props.isOpen, onClickNoBtn = props.onClickNoBtn, onClickYesBtn = props.onClickYesBtn;
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: isOpen,
        closeIcon: true,
        backdropEnable: true,
        onClose: onClickNoBtn,
        padding: "15px 0px 0px 15px",
        headerIcon: YellowWarningIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        padding: 0,
        margin: 0
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("Confirm Odometer Change")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: 'secondary.600',
        marginTop: 2
    }, t("By clicking the 'Odometer Change' checkbox, the system will reset the vehicle's reading to zero after the invoice is processed")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: 'column',
            sm: 'row-reverse'
        },
        spacing: 2,
        paddingTop: 3,
        minWidth: '100%'
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "yes-btn",
        size: "medium",
        fullWidth: true,
        name: t("Confirm"),
        variant: "contained",
        onClick: onClickYesBtn
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "no-btn",
        size: "medium",
        fullWidth: true,
        name: t("Cancel"),
        variant: "outlined",
        style: {
            border: '1px solid secondary.600',
            color: 'secondary.600'
        },
        onClick: onClickNoBtn
    }))));
};
export default OdometerConfirmPopUp;
